import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { DataLayer } from '@alfa-bank/site-data-layer';

import { SegmentLink } from '../segment-link';

import { TopRow as Component } from './top-row';
import type { IDeps, TTopRow } from './models';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const TopRow = createWidget<IDeps, TTopRow>({
    DataLayer,
    SegmentLink,
})(Component);
